export enum Sort {
  priceAscending = "price_ascending",
  priceDescending = "price_descending",
  dateAscending = "date_ascending",
  date = "date",
}

export function sortFormString(sort: string): Sort {
  switch (sort) {
    case "price_ascending":
      return Sort.priceAscending;
    case "price_descending":
      return Sort.priceDescending;
    case "date_ascending":
      return Sort.dateAscending;
    default:
      return Sort.date;
  }
}
